var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M22 6.308v11.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H4.808c-.505 0-.933-.175-1.283-.525A1.745 1.745 0 0 1 3 17.692V6.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h15.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283ZM4.5 8.404h16V6.308a.294.294 0 0 0-.096-.212.294.294 0 0 0-.212-.096H4.808a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v2.096Zm0 3.192v6.096c0 .077.032.148.096.212a.294.294 0 0 0 .212.096h15.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212v-6.096h-16Z",
    fill: "currentColor"
  })));
};
export default SvgCreditCard;